import FrontLatestPosts from "@/Components/Front/Blocks/FrontLatestPosts";
import FrontLatestPostsMixed from "@/Components/Front/Blocks/FrontLatestPostsMixed";
import FrontSimpleHero from "@/Components/Front/Blocks/Hero/FrontSimpleHero";
import FrontLayout from "@/Layouts/System/FrontLayout";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import { Trans, useTranslation } from 'react-i18next';
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const NewsDashboard = ({ seo }) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.resolvedLanguage.toUpperCase();
    return (
        <FrontLayout breadcrumbs={[{ title: t('breadcrumbs.news'), current: true }]}>
            <FrontSeoMetaTags seo={seo}/>
            <FrontSimpleHero
                heading={<Trans i18nKey={'news_page.hero_heading'}/>}
                description={
                    <Trans i18nKey={'news_page.hero_description'}/>
                }
                links={[
                    { href: '#' + t('news_page.section_id_news'), title: t('news_page.section_title_news') },
                    (currentLanguage === 'PL' && { href: '#' + t('news_page.section_id_blog'), title: t('news_page.section_title_blog') }),
                    { href: '#' + t('news_page.section_id_reports'), title: t('news_page.section_title_reports') }
                ]}
            />
            <section id={t('news_page.section_mixed_posts')} className="my-20">
                <FrontLatestPostsMixed />
            </section>

            <section id={t('news_page.section_id_news')} className="my-20">
                <FrontLatestPosts postType={t('news_page.section_title_news')} taxEn='news' tax='aktualnosci' linkToAll={resolveLocaleRoute('front.news.loop', currentLanguage === 'PL' ? 'aktualnosci' : 'news' )} />
            </section>

            {currentLanguage === 'PL' && (
                <section id={t('news_page.section_id_blog')} className="my-20">
                    <FrontLatestPosts postType={t('news_page.section_title_blog')} taxEn='blog-en' tax='blog' linkToAll={resolveLocaleRoute('front.news.loop', currentLanguage === 'PL' ? 'blog' : 'blog-en' )} />
                </section>
            )}

            <section id={t('news_page.section_id_reports')} className="mt-20 xl:mb-40 lg:mb-30 md:mb-20 mb-16">
                <FrontLatestPosts postType={t('news_page.section_title_reports')} taxEn='reports' tax='raporty' linkToAll={resolveLocaleRoute('front.news.loop', currentLanguage === 'PL' ? 'raporty' : 'reports' )} />
            </section>


        </FrontLayout>
    );
};

export default NewsDashboard;